import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { handleRequest } from '~/infra/utils';
import { EmailOnBehalfTypes } from '~/models/EmailOnBehalfSettingsModel';
import { selectors } from '~/store/state-selectors';
import gmailLogo from '../../../assets/Gmail.png';
import outlookLogo from '../../../assets/Outlook.png';
import { getEmailProviderDetails } from './NotificationSettings.utils';
import styles from './SendEmailOnBehalfModal.module.scss';
export function SendEmailOnBehalfModal(param) {
    let { dismissModal } = param;
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const changeLocation = useIoContext().changeLocation;
    const { startLoader, stopLoader, showErrorToast } = useOverlayContext();
    const { logBI } = useStoreActions();
    const connectEmail = async (provider)=>{
        const providerDetails = getEmailProviderDetails(provider);
        logBI(providerDetails.biCodes.connect, {
            vendorId: businessId
        });
        if (businessId) {
            startLoader();
            const result = await handleRequest(api.notification.emailOnBehalf.connectEmailOnBehalf({
                businessId,
                provider,
                pageUrl: window.location.origin + window.location.pathname
            }));
            if (result.success) {
                changeLocation(result.data);
            } else {
                logBI(providerDetails.biCodes.authError, {
                    vendorId: businessId
                });
                showErrorToast("Failed to connect ".concat(provider, " account - please try again"), "start-".concat(provider, "-flow-error-toast"));
            }
            stopLoader();
        } else {
            logBI(providerDetails.biCodes.authError || 18503, {
                vendorId: businessId
            });
            showErrorToast('please refresh and try again', 'no-business-id-error-toast');
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        width: "640px",
        title: "Send emails using my own domain",
        testId: "send-email-on-behalf-modal",
        onSecondaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraph1",
                    className: styles.description,
                    children: [
                        "Using your own domain to send emails ensures brand consistency, making your communications more recognizable and trustworthy to clients. It also improves email deliverability, reducing the chances of your emails being marked as spam. ",
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("br", {}),
                        "Please choose an email platform to connect:"
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.buttons,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.MailButton,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.MailButtonImage,
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            src: gmailLogo,
                                            width: 35,
                                            height: 35
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "paragraph1",
                                            children: "Gmail"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: styles.ConnectButton,
                                    size: "small",
                                    skin: "primaryOutline",
                                    testId: "connect-gmail-button",
                                    onClick: ()=>connectEmail(EmailOnBehalfTypes.Gmail),
                                    children: "Connect your Gmail account"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.MailButton,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.MailButtonImage,
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            src: outlookLogo,
                                            width: 35,
                                            height: 35
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "paragraph1",
                                            children: "Outlook"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: styles.ConnectButton,
                                    size: "small",
                                    skin: "primaryOutline",
                                    testId: "connect-outlook-button",
                                    onClick: ()=>connectEmail(EmailOnBehalfTypes.Outlook),
                                    children: "Connect your Outlook account"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        secondaryButtonLabel: "Cancel"
    });
}
